import React from 'react';
import { FaStar, FaHeart, FaHome } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Μαρία Κωνσταντίνου',
      role: 'Ιδρύτρια & Διευθύντρια',
      bio: 'Με πάνω από 15 χρόνια εμπειρίας στη βιομηχανία ομορφιάς, η Μαρία ίδρυσε το Sororin με το όραμα να φέρει την πολυτέλεια στην καθημερινή περιποίηση.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Ελένη Παπαδοπούλου',
      role: 'Επικεφαλής Ανάπτυξης Προϊόντων',
      bio: 'Η Ελένη είναι χημικός με ειδίκευση στα καλλυντικά. Δημιουργεί φόρμουλες που συνδυάζουν επιστήμη και φύση για βέλτιστα αποτελέσματα.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Δημήτρης Αντωνίου',
      role: 'Διευθυντής Ποιότητας',
      bio: 'Ο Δημήτρης διασφαλίζει ότι κάθε προϊόν πληροί τα υψηλότερα πρότυπα ποιότητας και ασφάλειας πριν φτάσει στα χέρια των πελατών μας.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Σοφία Γεωργίου',
      role: 'Υπεύθυνη Εξυπηρέτησης Πελατών',
      role: 'Υπεύθυνη Εξυπηρέτησης Πελατών',
      bio: 'Η Σοφία είναι αφοσιωμένη στο να προσφέρει την καλύτερη δυνατή εμπειρία σε κάθε πελάτη, απαντώντας σε ερωτήσεις και παρέχοντας συμβουλές.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Νίκος Παπαδάκης',
      role: 'Διευθυντής Logistics',
      bio: 'Ο Νίκος διαχειρίζεται την εφοδιαστική αλυσίδα μας, εξασφαλίζοντας ότι κάθε παραγγελία παραδίδεται γρήγορα και με ασφάλεια.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta name="description" content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς." />
      </Helmet>

      <div className="about-container">
      <section className="about-hero">
        <h1>Η Ιστορία μας</h1>
        <p>
          Το Sororin γεννήθηκε από την αγάπη για την ομορφιά και την επιθυμία να προσφέρουμε 
          στις γυναίκες προϊόντα που συνδυάζουν την πολυτέλεια με τη φυσικότητα. Από το 2013, 
          δημιουργούμε καλλυντικά που όχι μόνο βελτιώνουν την εμφάνιση, αλλά και τρέφουν το 
          δέρμα με φυσικά συστατικά υψηλής ποιότητας.
        </p>
      </section>

      <section className="advantages-section">
        <div className="advantages-header">
          <h2>Οι Αξίες μας</h2>
          <p>
            Αυτό που μας κάνει μοναδικούς είναι η αφοσίωσή μας στην ποιότητα, την καινοτομία 
            και την προστασία του περιβάλλοντος.
          </p>
        </div>

        <div className="advantages-grid">
          <div className="advantage-card">
            <FaStar className="advantage-icon" />
            <h3>Αριστεία στην Ποιότητα</h3>
            <p>
              Κάθε προϊόν περνάει από αυστηρούς ελέγχους ποιότητας και πιστοποιείται από 
              διεθνείς οργανισμούς πριν φτάσει στα χέρια σας.
            </p>
          </div>

          <div className="advantage-card">
            <FaHeart className="advantage-icon" />
            <h3>Αγάπη για τη Φύση</h3>
            <p>
              Χρησιμοποιούμε αποκλειστικά φυσικά και βιολογικά συστατικά που σέβονται το 
              δέρμα σας και το περιβάλλον.
            </p>
          </div>

          <div className="advantage-card">
            <FaHome className="advantage-icon" />
            <h3>Ελληνική Παραγωγή</h3>
            <p>
              Όλα τα προϊόντα μας παράγονται στην Ελλάδα με παραδοσιακές μεθόδους και 
              σύγχρονη τεχνολογία.
            </p>
          </div>
        </div>
      </section>

      <section className="team-section">
        <h2>Η Ομάδα μας</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-image-wrapper">
                <img 
                  src={member.image} 
                  alt={`Team member ${member.id}`}
                  className="team-image"
                  width="400"
                  height="400"
                />
              </div>
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="company-info-section">
        <h2>Στοιχεία Εταιρείας</h2>
        <div className="company-details">
          <div className="company-detail-item">
            <h3>Η Αποστολή μας</h3>
            <p>
              Στο Sororin, η αποστολή μας είναι να δημιουργούμε προϊόντα ομορφιάς που 
              εμπνέουν αυτοπεποίθηση και αναδεικνύουν τη φυσική ομορφιά κάθε γυναίκας. 
              Πιστεύουμε ότι η αληθινή ομορφιά ξεκινάει από μέσα, και τα προϊόντα μας 
              είναι σχεδιασμένα να ενισχύσουν αυτή την εσωτερική λάμψη.
            </p>
          </div>

          <div className="company-detail-item">
            <h3>Το Όραμά μας</h3>
            <p>
              Οραματιζόμαστε ένα μέλλον όπου κάθε γυναίκα έχει πρόσβαση σε προϊόντα 
              ομορφιάς υψηλής ποιότητας που είναι φυσικά, αποτελεσματικά και προσιτά. 
              Θέλουμε να γίνουμε η πρώτη επιλογή για γυναίκες που αναζητούν πολυτέλεια 
              χωρίς συμβιβασμούς στην ποιότητα ή στις αξίες τους.
            </p>
          </div>

          <div className="company-detail-item">
            <h3>Η Δέσμευσή μας</h3>
            <p>
              Δεσμευόμαστε να παράγουμε προϊόντα με υπευθυνότητα, χρησιμοποιώντας βιώσιμες 
              πρακτικές και σεβόμενοι το περιβάλλον. Κάθε προϊόν είναι cruelty-free, 
              δερματολογικά δοκιμασμένο και κατασκευασμένο με αγάπη και προσοχή στην 
              λεπτομέρεια.
            </p>
          </div>

          <div className="company-detail-item">
            <h3>Νομικές Πληροφορίες</h3>
            <p>
              <strong>Επωνυμία:</strong> Sororin Beauty Salon<br />
              <strong>Αριθμός Μητρώου:</strong> 77764607<br />
              <strong>Έτος Ίδρυσης:</strong> 2013<br />
              <strong>Διεύθυνση:</strong> Λεωφόρος Βενιζέλος, 2, 898 60, Λαγκαδάς, Greece
            </p>
          </div>
        </div>
      </section>
    </div>
  
    </>);
}

export default About;